/**
 * Service for area list operations
 */

import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import { buildQueryString } from '@/api/shared/queryBuilder';
import type { ApiResponse } from '@/api/shared/types';
import { mapAreasListFromTransport } from '../mappers';
import type {
  AreasListFilters,
  AreasListResult,
  LC_GetCompanyAreasListOut,
} from '../types';


export class AreaListService {
  /**
   * Get paginated list of areas with optional filters
   */
  async list(
    filters?: AreasListFilters,
  ): Promise<ApiResponse<AreasListResult>> {
    const queryString = buildQueryString(filters ?? {});
    const endpoint = `${API_CONFIG.ENDPOINTS.ORGANIZATION.AREAS}${queryString}`;

    const response = await apiClient.get<LC_GetCompanyAreasListOut>(endpoint);

    if (response.success && response.data) {
      return {
        ...response,
        data: mapAreasListFromTransport(response.data),
      };
    }

    return { ...response, data: null };
  }
}

export const areaList = new AreaListService();
